import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/loading.gif'
import _imports_1 from '../assets/detail.svg'


const _hoisted_1 = { class: "first-loading" }
const _hoisted_2 = {
  key: 0,
  class: "no-data"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "user_payment_transfer__list"
}
const _hoisted_5 = ["onClick"]

import { ProjectStore } from "../store/ProjectStore";
import { onMounted, ref } from "vue";
import { BASEURL } from "../consts/common";
import { NO_DATA } from "../consts/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserPaymentTransfers',
  setup(__props) {

const projectStore = ProjectStore();
document.title = "支払い通知書一覧";
const loading = ref(true);

onMounted(async () => {
  loading.value = true;
  if (!projectStore.userPaymentTransfers.length) {
    await projectStore.getUserPaymentTransfers();
  }
  loading.value = false;
});

// ページ遷移
function push(url: string) {
  window.open(BASEURL + url);
}

function list() {
  return projectStore.userPaymentTransfers;
}

// }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user_payment_transfer", [list().length ? 'background' : '']])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _cache[0] || (_cache[0] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
    ]), 512 /* NEED_PATCH */), [
      [_vShow, loading.value]
    ]),
    (!list().length && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(NO_DATA).get(5).img
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list(), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (push(item.url)),
              class: "list__item"
            }, [
              _createElementVNode("p", null, _toDisplayString(item.year) + "年" + _toDisplayString(item.month) + "月", 1 /* TEXT */),
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                class: "detail_icon",
                src: _imports_1,
                align: "right"
              }, null, -1 /* HOISTED */))
            ], 8 /* PROPS */, _hoisted_5))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ], 2 /* CLASS */))
}
}

})